import { render, staticRenderFns } from "./MenuListItem.vue?vue&type=template&id=855e0f20&"
import script from "./MenuListItem.vue?vue&type=script&lang=ts&"
export * from "./MenuListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports